// extracted by mini-css-extract-plugin
export default {"footerDiv":"Footer_footerDiv__h+Jo6"};